import Autocomplete from "@material-ui/lab/Autocomplete"
import { Box, TextField, Typography } from "@material-ui/core"
import type { HourReportAdminAssignmentOption } from "../../../../memberships/api/schemas"
import type { HourReportingAdminsTranslations } from "../hooks/use-translations"

type AdminSelectorProps = {
  options: HourReportAdminAssignmentOption[]
  value: HourReportAdminAssignmentOption | null
  disabled: boolean
  translations: HourReportingAdminsTranslations
  onChange: (option: HourReportAdminAssignmentOption | null) => void
}

export const AdminSelector = ({ options, value, disabled, translations, onChange }: AdminSelectorProps) => {
  const sortedOptions = [...options].sort((a, b) => a.name.localeCompare(b.name))

  return (
    <Autocomplete
      value={value}
      options={sortedOptions}
      disabled={disabled}
      onChange={(_, option) => onChange(option)}
      getOptionLabel={(option) => option.name}
      getOptionSelected={(option, selectedOption) => option.id === selectedOption.id}
      noOptionsText={translations.noOptionsText}
      renderOption={(option) => (
        <Box>
          <Typography variant="subtitle2">{option.name}</Typography>
          <Typography variant="body2" color="textSecondary">
            {option.email}
          </Typography>
        </Box>
      )}
      renderInput={(params) => (
        <TextField {...params} variant="outlined" size="small" placeholder={translations.searchMembersPlaceholder} />
      )}
    />
  )
}
